/// <reference path="./../Entity/PageBody.ts" />
namespace HA.Core.Service {

    import Body = HA.Core.Entity.PageBody;
    import HANavigationApp = HA.Core.Entity.HANavigationApp;

    export class PageBodyService extends Service {

        public reloadNav(nav: HANavigationApp) {
            this.getBody().reloadNav(nav);
        }

        public showAppMenu(menuData: Array<Map<any, any>>) {
            this.getBody().showAppMenu(menuData);
        }

        /**
         * @returns {Map<any, any>}
         */
        public getAppData(): Map<any, any>
        {
            return this.getBody().getAttributes([
                "id", "_id", "_1", "app", "nav", "q", "r", "navigationId", "controllerName",
                "controllerNamespace", "d", "_e", "_s", "_m", "attribute", "mainid", "noReload"
            ]);
        }

        /**
         *
         * @returns AppManager
         */
        public getAppManager() {
            return this.getBody().getAppManager();
        }

        /**
         *
         * @param app
         */
        public showApp(app: any) {
            const body = this.getBody();
            if (body) {
                return body.showApp(app);
            }
        }

        protected getBody(): Body {
            return this.get("pageBody");
        }

        /**
         *
         * @param data
         */
        protected initialize(data?: any) {
            super.initialize(data);
            this.addToData("pageBody", new Body(data));
        }
    }
}
